import * as React from "react"
import { batch } from "@preact/signals-react"
import { Box, Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"
import { FORMAT_DATE_BACK, formatDate, getPreviousDate } from "@ui-seeker/utils"

import { DATE_PERIODS } from "@constants"
import { SkuInfoBlock } from "@components"
import { useBuildExternalURL } from "@hooks"
import { commonFiltersValue } from "@signals"
import { evolutionSkuCurrentPeriod, evolutionSkuDataFilters, priceDiscountEndDate } from "Pages/Pricing/PriceDiscount/@signals"


export default function skuRetailerColumn() {
	return {
		name: 'sku', label: 'Product Name',
		options: {
			headerAlign: 'left',
			customBodyRowRenderLite: (value, { category, brand, ean, skuID, productID, myMainSiteID, country, reference }) =>
                <SkuRetailerCell
                    sku={value}
                    productID={productID}
                    category={category}
                    brand={brand}
                    ean={ean}
                    skuID={skuID}
                    myMainSiteID={myMainSiteID}
                    country={country}
                    reference={reference}
                />
		}
	}
}

const SkuRetailerCell = ({ sku, productID, category, brand, ean, skuID, myMainSiteID, country, reference}) => {
    const newFilters = commonFiltersValue.peek()
    const { productURL } = useBuildExternalURL({ siteData: { siteID: myMainSiteID, productID } })

    const handleClick = () => { batch(() => {
        priceDiscountEndDate.value = newFilters.endDate
        let startDate = formatDate(getPreviousDate({days: 6}, priceDiscountEndDate.value), { format: FORMAT_DATE_BACK, receivedFormat: "%Y-%m-%dT%H:%M:%S.%LZ" })

        evolutionSkuCurrentPeriod.value = DATE_PERIODS.LAST_7_DAYS

        evolutionSkuDataFilters.value = {
            ...commonFiltersValue.peek(),
            startDate: startDate,
            endDate: priceDiscountEndDate.value,
            sku: [skuID],
            country:[country]
        }
    })}

    return <Box sx={{ maxHeight: 110, display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
        <SkuInfoBlock
            sku={sku}
            productURL={productURL}
            category={category}
            brand={brand}
            ean={ean}
            skuID={skuID}
            reference={reference}
        />  

        <Box sx={{ display: 'flex', alignItems: 'flex-end'}} onClick={handleClick} >
            <Typography variant="caption" sx={{ display: 'block', color: "text.primary", mt: 1, mr: 0.5, cursor: 'pointer', "&:hover":{ textDecoration: 'underline'} }}>
                Show Price Evolution 
            </Typography>
            <IconSeeker icon={'chart-line'} sx={{ mr: 0.5, margin: .5, color: 'primary.main'}}/>
        </Box>
    </Box>
}